<template>
  <div
    class="mt-8 flex items-center gap-3 px-5 py-4 rounded-[12px] border border-[#E5E5E5] bg-[#FAFAFA]"
    data-testid="cockpit-impact-link"
  >
    <span class="text-[18px] shrink-0" aria-hidden="true">💡</span>
    <p class="text-[13px] text-[var(--color-disabled)] flex-1 m-0">
      {{ $t('UserProjects.cockpit.impact.hint') }}
    </p>
    <router-link
      to="/user-projects/impact-analysis"
      class="text-[13px] font-medium shrink-0 no-underline hover:underline"
      style="color: #e4821a"
    >
      {{ $t('UserProjects.cockpit.impact.cta') }}
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'CockpitImpactAnalysisLink',
};
</script>
